import { Injectable } from '@angular/core';
import { getGoogleAuthRedirectUrl } from '@lib/auth/utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  private readonly config = {
    googleOAuthUrl: 'https://accounts.google.com/o/oauth2/auth',
    scope: 'openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    responseType: 'code',
    accessType: 'offline',
  };

  login(): void {
    window.location.href = this.buildAuthUrl(environment.googleClientId, getGoogleAuthRedirectUrl(window));
  }

  private buildAuthUrl(clientId: string, redirectUri: string): string {
    const { googleOAuthUrl, responseType, accessType, scope } = this.config;

    return `${googleOAuthUrl}?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}&access_type=${accessType}&scope=${encodeURIComponent(
      scope,
    )}&state=google`;
  }
}
